import React from 'react';
import UpcomingDriveCard from './UpcomingDriveCard';
import Container from 'src/components/shared/Container';
import { Button, Spinner } from 'flowbite-react';
import { BsArrowLeft } from 'react-icons/bs';
import { useGetAllDrivesQuery } from 'src/hooks/drives.hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';
import { useUserContext } from 'src/context/UserProvider';

const UpcomingDriveListing = ({ onBack }: { onBack?: () => void }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const { isAccountManagerLoggedIn } = useUserContext();
	const { data, isLoading } = useGetAllDrivesQuery({
		showInternalDrives: isAccountManagerLoggedIn,
	});

	return (
		<Container className="flex justify-center">
			<div className="pb-40 pt-6 w-full">
				<div className="w-full mx-auto max-w-max flex flex-col items-center justify-center gap-[16px]">
					<h2 className="font-inter text-[24px] font-[700] leading-[30px] text-[#28293D]">Upcoming Drives</h2>
					{isLoading ? (
						<div>
							{/* <Spinner /> */}
							<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
						</div>
					) : (
						data?.drives.map(card => {
							return (
								<UpcomingDriveCard
									id={card._id}
									key={card._id}
									image={'/assets/calender.png'}
									title={card.city + ' Offline Placement Drive'}
									location={card.location}
									time={card.driveDate}
									endTime={card.driveEndDate ?? null}
									isRegistered={card.isRegistered}
									totalParticipating={card.totalParticipating}
								/>
							);
						})
					)}
				</div>
				<div className="bg-white w-full flex justify-center inset-x-0 dark:bg-[#111E2C] fixed items-center gap-5 bottom-0 shadow-up px-[16px] md:px-[24px] mx-auto">
					<div className="max-w-[347px] flex items-center justify-center gap-[8px] py-[19px] w-full">
						<Button
							type="button"
							color="light"
							className="max-w-[34px] w-full"
							onClick={() => {
								if (onBack) {
									onBack();
								} else {
									navigate(-1);
									setTimeout(() => {
										if (location.pathname === window.location.pathname) {
											// If we're still on the same page, navigate to a fallback route
											navigate('/select-hiring-type');
										}
									}, 100);
								}
							}}
						>
							<BsArrowLeft />
						</Button>
						<Button
							type="button"
							color="purplePlaced"
							onClick={() => {
								navigate('/fresher-candidates');
							}}
							className="max-w-[299px] w-full"
						>
							{'Explore Candidates'}
						</Button>
					</div>
				</div>
			</div>
		</Container>
	);
};

export default UpcomingDriveListing;
